import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./toast"
import { useToast } from "./use-toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      {/* Sotto la barra di stato (tacca dell'iPhone, e la striscia dell'orologio
          nell'app installata) e sopra le finestre, anche sopra il login a tutto
          schermo (z 100, che viene dopo nel DOM). */}
      <ToastViewport className="z-[110] pt-[calc(var(--nva-screen-top,0px)+16px)]" />
    </ToastProvider>
  )
}

